import { defineStore } from 'pinia'

interface SelectedArea {
  projectId: string
  code: string
  name: string
}

// Monitoring UI state shared across the Monitoring / Alerts / Imagery tabs:
// the map-selected area and the alert feed signal coming in over WS.
export const useMonitoringStore = defineStore('monitoring', {
  state: () => ({
    // null means "all areas"
    selectedArea: null as SelectedArea | null,
    unreadAlerts: 0,
    // Bumped on every incoming WS alert so pages can react without an event bus.
    alertTick: 0,
    lastAlert: null as unknown,
  }),

  actions: {
    setSelectedArea({ projectId, code, name }: { projectId: number | string, code: string, name: string }) {
      this.selectedArea = { projectId: String(projectId), code, name }
    },
    clearSelectedArea() {
      this.selectedArea = null
    },
    setUnreadAlerts(count: number) {
      this.unreadAlerts = count
    },
    alertReceived(alert: unknown) {
      this.lastAlert = alert
      this.alertTick += 1
      this.unreadAlerts += 1
    },
  },
})
